export default __webpack_public_path__ + "static/media/chris.5da0bb35.jpeg";